var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1686_43138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4583 30.6316C32.4583 29.0008 32.4583 28.1855 32.7991 27.7303C33.0961 27.3336 33.5507 27.0854 34.045 27.0501C34.6121 27.0096 35.298 27.4505 36.6697 28.3323L52.7984 38.7008C53.9888 39.466 54.5839 39.8486 54.7895 40.3351C54.9691 40.7602 54.9691 41.2398 54.7895 41.6649C54.5839 42.1514 53.9888 42.534 52.7984 43.2992L36.6697 53.6677C35.298 54.5495 34.6121 54.9904 34.045 54.9499C33.5507 54.9146 33.0961 54.6664 32.7991 54.2697C32.4583 53.8145 32.4583 52.9992 32.4583 51.3684V30.6316Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 26.65C10.25 20.9095 10.25 18.0392 11.3672 15.8466C12.3499 13.9179 13.9179 12.3499 15.8466 11.3672C18.0392 10.25 20.9095 10.25 26.65 10.25H55.35C61.0905 10.25 63.9608 10.25 66.1534 11.3672C68.0821 12.3499 69.6501 13.9179 70.6328 15.8466C71.75 18.0392 71.75 20.9095 71.75 26.65V55.35C71.75 61.0905 71.75 63.9608 70.6328 66.1534C69.6501 68.0821 68.0821 69.6501 66.1534 70.6328C63.9608 71.75 61.0905 71.75 55.35 71.75H26.65C20.9095 71.75 18.0392 71.75 15.8466 70.6328C13.9179 69.6501 12.3499 68.0821 11.3672 66.1534C10.25 63.9608 10.25 61.0905 10.25 55.35V26.65Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 59,
    width: 42.6667,
    height: 22.8333,
    rx: 3.41667,
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5376 64.9773H47.9741L51.352 73.2277H51.4685L54.8463 64.9773H56.2828V74.9167H55.1569V67.365H55.0598L51.9538 74.9167H50.8667L47.7606 67.365H47.6635V74.9167H46.5376V64.9773ZM58.6961 74.9167V64.9773H62.0545C62.8343 64.9773 63.4717 65.118 63.9667 65.3995C64.465 65.6777 64.8338 66.0547 65.0732 66.5303C65.3127 67.0059 65.4324 67.5365 65.4324 68.1221C65.4324 68.7078 65.3127 69.24 65.0732 69.7189C64.8371 70.1977 64.4714 70.5795 63.9764 70.8642C63.4814 71.1457 62.8472 71.2864 62.074 71.2864H59.6668V70.2187H62.0351C62.569 70.2187 62.9977 70.1265 63.3212 69.9421C63.6448 69.7577 63.8794 69.5086 64.0249 69.1947C64.1738 68.8776 64.2482 68.5201 64.2482 68.1221C64.2482 67.7242 64.1738 67.3683 64.0249 67.0544C63.8794 66.7406 63.6432 66.4947 63.3164 66.3168C62.9896 66.1356 62.556 66.045 62.0157 66.045H59.8997V74.9167H58.6961ZM66.9636 72.8783V71.8882L71.3315 64.9773H72.0497V66.5109H71.5644L68.2642 71.7329V71.8106H74.1463V72.8783H66.9636ZM71.6421 74.9167V72.5774V72.1163V64.9773H72.7874V74.9167H71.6421Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1686_43138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/MP4.f3b8308bb45e3968ef73e6295fcfe27c.svg";
export { ForwardRef as ReactComponent };